import React from 'react';
import { motion } from 'framer-motion';
import { TestimonialCard } from './TestimonialCard';
const items = [{
  text: '"Llevaba semanas sin dormir y sin entender por qué mi bebé lloraba tanto. El Manual de Respuestas me explicó exactamente qué le pasaba y qué hacer. Por fin pude ayudarle de verdad."',
  author: 'Ana M. — Madrid'
}, {
  text: '"Lo que más me sorprendió es la claridad con la que explica el desarrollo del bebé mes a mes. Dejé de preocuparme por todo porque por fin entendía qué era normal y qué no."',
  author: 'Carlos R. — Barcelona'
}, {
  text: '"Habíamos leído de todo y nada nos daba un sistema claro. Este sistema tiene todo organizado. Sabemos qué leer según el problema que tengamos ese día. Ha cambiado nuestra forma de vivir la crianza."',
  author: 'Sara y Pablo — Valencia'
}];
export function TestimonialsHero() {
  return <div className="bg-[#f4f6fa] py-12 px-5" data-id="element-176">
      <div className="max-w-[960px] mx-auto grid gap-5 grid-cols-1 md:grid-cols-3" data-id="element-177">
        {items.map((t, i) => <motion.div key={t.author} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5,
        delay: i * 0.1
      }} data-id="element-178">
            <TestimonialCard {...t} data-id="element-179" />
          </motion.div>)}
      </div>
    </div>;
}